var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ImportDiscoveryTask_1;
import '@symon-ai/wisepipe-common-connection'; // force import for JsonSchema
import { DateConverter, JSON, JsonConverter, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { OrgPlan } from '@symon-ai/wisepipe-user';
import '@symon-ai/wisepipe-common'; // force import for JsonSchema
import { Utils } from '@symon-ai/wisepipe-common';
import './extractionParameters'; // force import for JsonSchema
import './importConfigs/importConfig'; // force import for JsonSchema
import './importDiscoveryCatalogEntry'; // force import for JsonSchema
export var ImportDiscoveryStatus;
(function (ImportDiscoveryStatus) {
    ImportDiscoveryStatus["RUNNING"] = "running";
    ImportDiscoveryStatus["COMPLETED"] = "completed";
    ImportDiscoveryStatus["FAILED"] = "failed";
})(ImportDiscoveryStatus || (ImportDiscoveryStatus = {}));
const ImportDiscoverySchema = {
    $id: 'urn:wisepipe-common-data:ImportDiscoveryTask',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: Object.values(OrgPlan) },
        discoveryID: { type: 'string', uid: 9 },
        status: {
            type: 'string',
            enum: ['running', 'completed', 'failed']
        },
        importConfig: { $ref: 'urn:wisepipe-common-data:ImportConfig' },
        transient: { type: 'boolean' },
        startTime: { type: 'string', format: 'date-time' },
        endTime: { type: 'string', format: 'date-time' },
        connection: { $ref: 'urn:wisepipe-common-connection:Connection' },
        catalog: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:ImportDiscoveryCatalogEntry' },
            uniqueItems: true
        },
        error: { type: 'object' },
        extractionParameters: { $ref: 'urn:wisepipe-common-data:ExtractionParameters' },
        catalogS3Url: { $ref: 'urn:wisepipe-common:S3File' },
        importID: { type: 'string', uid: 9 },
        columnsToUpdateS3Url: { $ref: 'urn:wisepipe-common:S3File' },
        sourceFileName: { type: 'string' }
    },
    if: { properties: { status: { const: ImportDiscoveryStatus.FAILED } } },
    then: { required: ['error'] },
    required: ['discoveryID', 'status', 'importConfig']
};
let ImportDiscoveryTask = ImportDiscoveryTask_1 = class ImportDiscoveryTask {
    constructor(orgID, discoveryID, status, importConfig, transient, startTime, endTime, connection, catalog, error, extractionParameters, orgPlan, catalogS3Url, importID, columnsToUpdateS3Url, sourceFileName) {
        this.orgID = orgID;
        this.orgPlan = orgPlan;
        this.discoveryID = discoveryID;
        this.status = status;
        this.importConfig = importConfig;
        this.startTime = startTime;
        this.endTime = endTime;
        this.transient = transient;
        this.connection = connection;
        this.catalog = catalog;
        this.error = error;
        this.extractionParameters = extractionParameters;
        this.catalogS3Url = catalogS3Url;
        this.importID = importID;
        this.columnsToUpdateS3Url = columnsToUpdateS3Url;
        this.sourceFileName = sourceFileName;
        JSON.validate(this, ImportDiscoveryTask_1);
    }
    static newID() {
        return Utils.newID();
    }
    static bufferID(discoveryID) {
        return Utils.base64StringToBuffer(discoveryID);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], ImportDiscoveryTask.prototype, "startTime", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], ImportDiscoveryTask.prototype, "endTime", void 0);
ImportDiscoveryTask = ImportDiscoveryTask_1 = __decorate([
    JsonSchema(ImportDiscoverySchema)
], ImportDiscoveryTask);
export { ImportDiscoveryTask };
//# sourceMappingURL=importDiscoveryTask.js.map